import React from 'react'
import "./UplodRellsSection.css"
import Form from './Form'
const UplodRellsSection = () => {
  return (
    <div className='caderFrom'>
        <Form/>
    </div>
  )
}

export default UplodRellsSection